import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {
    GOOGLE_LOGIN_URL,
    LOGOUT_URL,
    SURVEYS_URL
} from "../constants";
import Payments from "./Payments";

const Header = (props) => {
    const {user} = props;

    const renderContent = (user) => {
        switch (user) {
            case null:
                return;
            case false:
                return (<li><a href={GOOGLE_LOGIN_URL}>Login With Google</a></li>);
            default:
                return <>
                    <li key={3}>
                        <span style={{
                            margin: '0 10px'
                        }}>Credits: {user.credits}</span>
                    </li>
                    <li key={1}><Payments/></li>
                    <li key={2}><a href={LOGOUT_URL}>Logout</a></li>
                </>;
        }
    };

    const renderedLogoLink = user => (
        <Link to={user ? SURVEYS_URL : '/'}
              className="left brand-logo">
            Emailie
        </Link>);


    return (
        <nav>
            <div className="nav-wrapper">
                <div className="nav-content">
                    {renderedLogoLink(user)}
                    <ul className="right">
                        {renderContent(user)}
                    </ul>
                </div>

            </div>
        </nav>
    );
};

const mapStateToProps = ({auth}) => {
    return auth;
};

export default connect(mapStateToProps)(Header);